import Chart from 'chart.js';
export default function TileObjectsChart(chartId, tileLayer) {
  var lastValidCompareIndex = 0;
  var timestamp = Date.now();
  var viewLevelStartDataset = {
    label: 'Update 1st level',
    data: [{
      x: 0,
      y: 0
    }]
  };
  var viewUpdateDurationDataset = {
    label: 'Update duration (ms)',
    data: [{
      x: 0,
      y: 0
    }],
    borderColor: 'rgba(75,192,192,1)'
  };
  var label = ['0s'];
  var nbObjectsChart = new Chart(chartId, {
    type: 'line',
    data: {
      labels: label,
      datasets: [viewLevelStartDataset, viewUpdateDurationDataset]
    },
    options: {
      animation: {
        duration: 10
      },
      scales: {
        yAxes: [{
          display: true,
          ticks: {
            suggestedMin: 0 // minimum will be 0, unless there is a lower value.

          }
        }]
      }
    }
  });

  this.update = function (displayed, updateDuration) {
    // update line graph
    // update time
    var limit = 60;
    var timeInS = Math.floor((Date.now() - timestamp) / 1000);
    var lbl = "".concat(timeInS, "s");
    var identical = lastValidCompareIndex > 0 && label[lastValidCompareIndex] == lbl;

    if (identical) {
      label.push('');
    } else {
      label.push(lbl);
      lastValidCompareIndex = label.length - 1;
    }

    if (label.length > limit) {
      label.shift();
      lastValidCompareIndex--;
    }

    viewLevelStartDataset.data.push({
      x: 0,
      y: tileLayer._latestUpdateStartingLevel
    });
    viewUpdateDurationDataset.data.push({
      x: 0,
      y: updateDuration
    });

    if (viewLevelStartDataset.data.length > limit) {
      viewLevelStartDataset.data.shift();
      viewUpdateDurationDataset.data.shift();
    }

    if (displayed) {
      nbObjectsChart.update();
    }
  };

  this.resize = function () {
    nbObjectsChart.resize();
  };
}